import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AppConfiguration } from '../conf/app.configuration';
import { AuthService } from '../auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { DELETE_USER } from '../store/user';
import { of, Observable } from 'rxjs';


@Injectable()
export class AuthGuard1FA implements CanActivate {
  private loginRoute: string;

  constructor(
    protected appConfig: AppConfiguration,
    protected auth: AuthService,
    protected router: Router,
    protected store: Store<AppState>
  ) {
    this.loginRoute = appConfig.getValue('login.page');
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.auth.isLoggedIn(true)) {
      return of(true);
    } else {
      console.log('Acceso no permitido: redireccionando a login: ', state.url);
      this.store.dispatch(DELETE_USER({}));

      // no establecer redirectTo si es login (si no se producirá un bucle infinito)
      if (state.url !== this.loginRoute) {
        sessionStorage.setItem('login.redirectTo', state.url);
      }

      this.router.navigate([this.loginRoute]);
      return of(false);
    }
  }
}
